var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / show-more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,11.25 C8.89949494,11.25 11.25,8.89949494 11.25,6 C11.25,3.10050506 8.89949494,0.75 6,0.75 C3.10050506,0.75 0.75,3.10050506 0.75,6 C0.75,8.89949494 3.10050506,11.25 6,11.25 Z M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z M6,2.25 C6.41421356,2.25 6.75,2.58578644 6.75,3 L6.749,5.25 L9,5.25 C9.41421356,5.25 9.75,5.58578644 9.75,6 C9.75,6.41421356 9.41421356,6.75 9,6.75 L6.749,6.75 L6.75,9 C6.75,9.41421356 6.41421356,9.75 6,9.75 C5.58578644,9.75 5.25,9.41421356 5.25,9 L5.249,6.75 L3,6.75 C2.58578644,6.75 2.25,6.41421356 2.25,6 C2.25,5.58578644 2.58578644,5.25 3,5.25 L5.249,5.25 L5.25,3 C5.25,2.58578644 5.58578644,2.25 6,2.25 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Icons---.75em-(12px)",
    transform: "translate(-191.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-show-more",
    transform: "translate(191.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#0E67A9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "$color-text-link-on-light",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/show-more.362ab43556463a290a342e106680ecaf.svg";
export { ForwardRef as ReactComponent };